import React,{ Component } from 'react';
import './App.scss';
import { BrowserRouter as Router , Route, Switch } from 'react-router-dom';
import loadable from '@loadable/component';

const LoadingUserPage = loadable(() => import('./components/loading/UserPage'));
const LoadingHome = loadable(() => import('./components/loading/Home'));

const UserPage = loadable(() => import('./pages/User'), {
  fallback: <LoadingUserPage />,
});
const Home = loadable(() => import('./pages/Home'), {
  fallback: <LoadingHome />,
});

export class App extends Component {

  fade=()=>{
    const square=document.getElementById("circle");

    square.style.opacity='0';
  }

  render(){
    return (
      <Router>
          <div className="app">
              <Switch>
                  <Route exact path="/t/:team_path" render={(props) => <UserPage {...props} />} />
                  <Route path="/event/:event_id/:question_id" render={(props) => <Home {...props} type="question" />} />
                  <Route exact path="/reschedule/:schedule_id" render={(props) => <Home {...props} type="reschedule" />} />
                  <Route path="/t/:team_path/:event_id" render={(props) => <Home {...props} type="event" />} />
                  {window.location.hostname === process.env.REACT_APP_BASE_URL &&<Route exact path="/:user_path" render={(props) => <UserPage {...props} />} />}
                  {window.location.hostname === process.env.REACT_APP_BASE_URL ? (
                      <Route path="/:user_path/:event_id" render={(props) => <Home {...props} type="event" />} />
                  ) : (
                      <Route path="/:event_id" render={(props) => <Home {...props} type="event" />} />
                  )}
                  <Route exact path='/' render={(props) => <UserPage {...props} />} />
                </Switch>
          </div>
      </Router>
    )
  }
}


export default App;
